import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, FileText, MessageSquare, Receipt, UserCog } from 'lucide-react';

// SUPPLIER V1 · Phase C · Module 13 — Mobile-First bottom nav
// Renders only on supplier pages. Designed for one-thumb operation.
export default function SupplierBottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    { path: '/supplier-dashboard', label: 'Home', icon: Home, testid: 'bottom-nav-home' },
    { path: '/supplier-dashboard?tab=available', label: 'Tenders', icon: FileText, testid: 'bottom-nav-tenders' },
    { path: '/supplier-dashboard/clarifications', label: 'Q&A', icon: MessageSquare, testid: 'bottom-nav-clarifications' },
    { path: '/supplier-dashboard/success-fees', label: 'Fees', icon: Receipt, testid: 'bottom-nav-fees' },
    { path: '/supplier-dashboard/profile', label: 'Profile', icon: UserCog, testid: 'bottom-nav-profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-30 md:hidden" data-testid="supplier-bottom-nav">
      <div className="grid grid-cols-5 max-w-md mx-auto">
        {items.map(it => {
          const Icon = it.icon;
          const active = pathname === it.path.split('?')[0];
          return (
            <button
              key={it.path}
              onClick={() => navigate(it.path)}
              className={`flex flex-col items-center justify-center py-2.5 px-1 transition-colors ${active ? 'text-orange' : 'text-muted-foreground hover:text-navy'}`}
              data-testid={it.testid}
            >
              <Icon className={`h-5 w-5 ${active ? 'text-orange' : ''}`} />
              <span className={`text-[10px] mt-0.5 font-semibold ${active ? 'text-orange' : ''}`}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
